import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootStore } from '../../../store/types';
import { getFinalizePoliciesDataAsync } from '../../../store/order/policy/getFinalizePoliciesDataAsync';
import { FinalizePolicies } from '../../../components/order/title/FinalizePolicies';
import { publishDocumentsAsync } from '../../../API/order/title/publishDocumentsAsync';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../types/shared/UUID';
import { useAppDispatch } from '../../../store/store';

interface IFinalizePolicesControllerProps {
  getCategoryLabel: (categoryName: string) => string;
}

export const FinalizePolicesController: React.FC<IFinalizePolicesControllerProps> = ({ getCategoryLabel }) => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const dispatch = useAppDispatch();
  const { feesCount, fetchErrors, fetchStatus, policyDocuments, sendErrors, sendStatus } = useSelector(
    ({ order }: RootStore) => order.uploadPolicies
  );
  const [showModal, setShowModal] = useState(false);
  const [submittedDocumentIds, setSubmittedDocumentIds] = useState<string[]>([]);
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    if (sendStatus.success) {
      window.location.reload();
    } else {
      setShowModal(false);
    }
  };
  const onSubmit = (documentIds: string[]) => {
    const unpublishedDocumentIds = policyDocuments
      .filter(({ client_published_at }) => !client_published_at)
      .map(({ id }) => id);
    setSubmittedDocumentIds(documentIds.filter((documentId) => unpublishedDocumentIds.includes(documentId)));
  };
  useEffect(() => {
    dispatch(getFinalizePoliciesDataAsync(orderId));
    setSubmittedDocumentIds([]);
  }, [dispatch, orderId]);
  useEffect(() => {
    if (submittedDocumentIds.length) {
      dispatch(publishDocumentsAsync(orderId, submittedDocumentIds));
    }
  }, [dispatch, orderId, submittedDocumentIds]);
  return (
    <FinalizePolicies
      fetchErrors={fetchErrors}
      fetchStatus={fetchStatus}
      feesCount={feesCount}
      policyDocuments={policyDocuments}
      sendErrors={sendErrors}
      sendStatus={sendStatus}
      submittedDocumentIds={submittedDocumentIds}
      showModal={showModal}
      closeModal={closeModal}
      openModal={openModal}
      onSubmit={onSubmit}
      getCategoryLabel={getCategoryLabel}
    />
  );
};
